module.exports = __webpack_public_path__ + "assets/settings_remote.c8b99517.svg";